<template>
  <div class="cart profile addProduct">
    <div class="card">
      <div class="card-body">
        <form class="form row" @keydown.enter.prevent>
          <div class="col-md-6">
            <div class="input">
              <label for="name">Название продукта</label>
              <input
                id="name"
                v-model="formData.name"
                type="text"
                class="form-control mt-2"
                placeholder="Введите название"
                required
              />
            </div>
            <div class="input mt-3">
              <label for="description">Описание</label>
              <textarea
                id="description"
                v-model="formData.description"
                type="text"
                class="form-control mt-2"
                rows="5"
                placeholder="Введите описание"
                required
              />
            </div>
            <div class="input images mt-3">
              <label for="inputGroupFile01">Фото товара</label>
              <input
                id="inputGroupFile01"
                ref="fileInput"
                type="file"
                class="form-control d-none"
                style="height: fit-content"
                multiple
                :disabled="productImages?.length >= 7"
                @change="onFileChange($event)"
              />
              <div v-if="productImages?.length < 8" class="selectImage mt-2" @click="triggerFileUpload">
                <img src="@/assets/images/icons/image.png" />
              </div>
              <div v-if="productImages?.length" class="images-selected mt-4">
                <div v-for="(item, index) in productImages" :key="index" class="images-selected__block">
                  <img class="close" src="@/assets/images/icons/close.svg" @click="deleteImg(index)" />
                  <img :src="item.image ? item.image : item" width="100" height="100" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="input-row">
              <label for="flexSwitchCheckDefault">В наличии</label>
              <input
                id="flexSwitchCheckDefault"
                v-model="formData.in_stock"
                type="checkbox"
                class="ms-2"
                role="switch"
                placeholder=""
              />
            </div>
            <div class="input-row mt-3">
              <label for="flexSwitchCheckDefault">Цена включает налоги</label>
              <input
                id="flexSwitchCheckDefault"
                v-model="formData.price_with_taxes"
                type="checkbox"
                class="ms-2"
                role="switch"
                placeholder=""
              />
            </div>
            <div class="input tags mt-3">
              <label for="tags">Теги</label>
              <div class="tag-input">
                <div class="tags-container">
                  <span v-for="(tag, index) in formTags" :key="index" class="tag">
                    {{ tag.name || tag }}
                    <button type="button" class="remove-tag" @click="removeTag(index)">&times;</button>
                  </span>
                  <input
                    v-model="newTag"
                    type="text"
                    class="form-control mt-2"
                    placeholder="Добавьте тег"
                    @keyup.enter="addTag"
                  />
                </div>
              </div>
            </div>
            <div v-if="productCategories?.length" class="input mt-3">
              <label for="floatingSelect">Категория</label>
              <select id="floatingSelect" v-model="formData.category" class="form-select mt-2">
                <option disabled value="">Выберите категорию</option>
                <option v-for="(item, index) in productCategories" :key="index" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class="input mt-3">
              <label for="floatingSelect">Компания</label>
              <select id="floatingSelect" v-model="formData.company" class="form-select mt-2">
                <option disabled value="">Выберите компанию</option>
                <option v-for="(item, index) in productCompanies" :key="index" :value="item.id">
                  {{ item.name_full }}
                </option>
              </select>
            </div>

            <!-- <div class="input mt-3">
              <label for="code">Код продукта</label>
              <input
                v-model="formData.product_code"
                type="text"
                class="form-control mt-2"
                id="code"
                placeholder="Введите код"
              />
            </div> -->
            <!-- <div class="input mt-3">
              <label for="sku">SKU продукта</label>
              <input
                v-model="formData.sku_article"
                type="text"
                class="form-control mt-2"
                id="sku"
                placeholder="Введите SKU"
                required
              />
            </div> -->
            <div class="input mt-3">
              <label for="price">Стоимость</label>
              <input
                id="price"
                v-model="formData.price"
                type="number"
                class="form-control mt-2"
                placeholder="Введите стоимость"
                required
              />
            </div>
            <div class="input mt-3">
              <label for="salePrice">Цена со скидкой <span>(необязательно)</span></label>
              <input
                id="salePrice"
                v-model="formData.sale_price"
                type="number"
                class="form-control mt-2"
                placeholder="Введите цену со скидкой"
                required
              />
            </div>
            <div class="error" role="alert">{{ error }}</div>
            <button class="black-button mt-4" @click.prevent="addProduct">Разместить</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted, computed } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import MarketplaceService from '@/services/marketplace';
  import CompanyService from '@/services/company';
  import productCategoriesService from '@/services/products';

  const router = useRouter();
  const store = useStore();
  const loggedIn = computed(() => store.state.auth.status.loggedIn);
  const currentUser = ref({});
  const productCategories = ref([]);
  const productCompanies = ref([]);
  // const productTags = ref([]);
  // const productTagsWithIds = ref([]);
  const fileInput = ref(null);
  const error = ref(null);
  const route = useRoute();

  const formData = ref({
    category: '',
    company: '',
  });
  // const formImages = ref([]);
  const formTags = ref([]);
  const productImages = ref([]);
  const newTag = ref('');

  onMounted(async () => {
    if (!loggedIn.value) {
      router.push('/');
    } else {
      const user = await store.dispatch('user/me');
      currentUser.value = user;
      // if (!currentUser.value.membership_exists) {
      //   router.push("/plans");
      // }

      CompanyService.getCompany(user.id).then((res) => {
        productCompanies.value = res.result;
      });

      productCategoriesService.all().then((res) => {
        productCategories.value = res;
      });
      if (route.params.id) {
        MarketplaceService.show(route.params.id).then((res) => {
          formData.value.name = res.name;
          formData.value.company = res.company;
          formData.value.description = res.description;
          formData.value.category = res.category.id;
          formData.value.price = parseFloat(res.price.toString().replace(',', '.'));
          formData.value.sale_price = parseFloat(res.sale_price.toString().replace(',', '.'));
          // formData.value.sku_article = res.sku_article;
          // formData.value.product_code = res.product_code;
          formTags.value = res.tags;
          productImages.value = res.images;
        });
      }
    }
  });

  const triggerFileUpload = () => {
    fileInput.value.click();
  };
  const onFileChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const images = event.target.files;
      Array.from(images).forEach((item) => {
        productImages.value.push({
          image: URL.createObjectURL(item),
          file: item,
        });
      });
    }
  };

  const deleteImg = async (index) => {
    await MarketplaceService.deleteImage(productImages.value[index].id);
    productImages.value.splice(index, 1);
    fileInput.value.value = null;
  };

  const getImagesFromFormData = (formData) => {
    const images = [];
    for (let [key, value] of formData.entries()) {
      if (key === 'images') {
        images.push(value);
      }
    }
    return images;
  };

  const addTag = () => {
    const trimmedTag = newTag.value.trim();
    if (trimmedTag && !formTags.value.includes(trimmedTag)) {
      formTags.value.push(trimmedTag);
      newTag.value = '';
    }
  };
  // Удаление тега
  const removeTag = (index) => {
    formTags.value.splice(index, 1);
  };

  const addProduct = async () => {
    const entries = Object.entries(formData.value);
    const newProduct = new FormData();

    // Добавляем текстовые данные в FormData
    entries.forEach(([key, value]) => {
      newProduct.append(key, value);
    });

    // Добавляем теги
    for (const item of formTags.value) {
      const data = {
        name: item,
      };
      await productCategoriesService.addTags(data).then((res) => {
        newProduct.append('tags', res.id);
      });
    }

    // Асинхронно обрабатываем изображения
    for (const item of productImages.value) {
      if (item.file) {
        newProduct.append('images', item.file); // Добавляем только новые файлы
      }
    }

    // Проверка всех обязательных полей
    const isFormValid =
      formData.value.name &&
      formData.value.company &&
      formData.value.description &&
      formData.value.category &&
      formData.value.price &&
      productImages.value.length >= 1;

    if (isFormValid) {
      const price = Number(formData.value.price);
      const salePrice = formData.value.sale_price ? Number(formData.value.sale_price) : null;

      if (salePrice !== null && salePrice > 0 && price <= salePrice) {
        error.value = 'Цена со скидкой должна быть меньше основной цены';
        return;
      }

      try {
        if (route.params.id) {
          const imgFormData = new FormData();
          const images = getImagesFromFormData(newProduct);
          images.forEach((image) => {
            imgFormData.append(`images`, image);
          });
          await MarketplaceService.update(route.params.id, newProduct);
          if (images.length) {
            await MarketplaceService.addImage(route.params.id, imgFormData);
          }
        } else {
          // Создание нового продукта
          await MarketplaceService.add(newProduct);
        }
        router.push('/profile/products');
      } catch (e) {
        error.value = 'Ошибка при сохранении данных';
      }
    } else {
      error.value = 'Заполните все обязательные поля и добавьте хотя бы одно фото';
    }
  };
</script>

<style scoped lang="scss">
  label span {
    color: #a1a1a1;
  }

  .selectImage {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 100px;

    text-align: center;

    background-color: #f7f7f7;
    border-radius: 10px;
    cursor: pointer;
  }

  .images {
    &-selected {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;

      &__block {
        position: relative;

        .close {
          position: absolute;
          top: 0.5rem;
          right: 0.5rem;

          cursor: pointer;
        }
      }
    }
  }

  .tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .tag {
    display: flex;
    align-items: center;
    padding: 5px 10px;

    background-color: #f0f0f0;
    border-radius: 5px;
  }

  .remove-tag {
    margin-left: 5px;

    font-size: 14px;

    background: none;
    border: none;
    cursor: pointer;
  }

  .form-control {
    min-width: 150px;
    padding: 5px 10px;

    border: 1px solid #ccc;
    border-radius: 5px;
  }
</style>
